import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import AppBarPortal from '../components/AppBarPortal';
import AppLeftPortal from '../components/AppLeftPortal';
import AppFooterPortal from '../components/AppFooterPortal';

const styles = {
  pl: {
    paddingLeft: 25
  }
}

class CookiePolicy extends React.PureComponent {

  state = {
    title: 'POLÍTICA DE COOKIES'
  }

  componentDidMount() {
    document.body.classList.add("login");
    document.title = this.state.title + ' - CosmoCare';
  }

  componentWillUnmount() {
    document.body.classList.remove("login");
  }

  render() {
    const { classes } = this.props

    return (
      <main style={{ display: 'block', padding: 25 }}>
        {!isMobile && <AppBarPortal />}
        {!isMobile && <AppLeftPortal />}
        {!isMobile && <AppFooterPortal />}
        
        <Grid container>
          <Grid item xs={12}>
            <Typography variant='headline' align='center' paragraph>
              POLÍTICA DE COOKIES
            </Typography>
            <Typography paragraph>
              La presente Política de Cookies es parte integrante del Aviso Legal y la Política de Protección de Datos 
              de https://cosmocare.eu, (en adelante, el “Sitio Web”). El acceso y la navegación en el Sitio Web, o el 
              uso de los servicios de la misma, implican la aceptación de los términos y condiciones recogidos en el Aviso 
              Legal y en la Política de Privacidad.
            </Typography>
            <Typography paragraph>
              Con el fin de facilitar su navegación por el Sitio Web https://www.cosmocare.eu titularidad de COSMOCARE EXPERT, 
              SOCIEDAD LIMITADA (en adelante, “COSMOCARE”), domiciliada en Calle Diputación, núm. 180, Oficinas B-C, 08011 
              Barcelona, con NIF B67255455, comunica al usuario que utiliza Cookies u otros archivos de funcionalidad similar 
              (en adelante, las “Cookies”).
            </Typography>
            <Typography paragraph>
              COSMOCARE es el responsable de las Cookies y del tratamiento de los datos obtenidos a través de las Cookies propias y 
              de terceros decidiendo sobre la finalidad, contenido y uso del tratamiento de la información recabada.
            </Typography>
            <Typography paragraph variant="subheading">
              ¿Qué es una Cookie?
            </Typography>
            <Typography paragraph>
              Las Cookies son archivos que contienen pequeñas cantidades de información que se descargan en el 
              dispositivo del usuario cuando visita una página web. Su finalidad principal es reconocer al usuario 
              cada vez que accede al Sitio Web permitiendo, además, mejorar la calidad y ofrecer un mejor uso del Sitio Web.
            </Typography>
            <Typography paragraph>
              Las Cookies son esenciales para el funcionamiento de Internet; no pueden dañar el equipo/dispositivo del 
              usuario y, si se encuentran activadas en la configuración del navegador, ayudan a identificar y resolver 
              posibles errores de funcionamiento del Sitio Web.
            </Typography>
            <Typography paragraph variant="subheading">
              Uso de Cookies por parte del prestador
            </Typography>
            <Typography paragraph>
              Mediante el acceso al Sitio Web, el usuario acepta de manera expresa la utilización de este 
              tipo de Cookies en sus dispositivos. Si desactiva las Cookies, puede que su navegación por el 
              Sitio Web no sea óptima y algunas de las utilidades de que dispone el Sitio Web no funcionen correctamente.
            </Typography>
            <Typography paragraph>
              Concretamente, utilizamos las Cookies para las finalidades que a continuación se exponen. Si utilizásemos 
              otras Cookies con el propósito de otorgar más y mejores servicios, se informará al usuario de ello.
            </Typography>
            <Typography paragraph variant="subheading">
              Cookies técnicas o “estrictamente necesarias”
            </Typography>
            <Typography paragraph>
              Son aquellas cookies consideradas imprescindibles para la navegación por el Sitio Web, pues facilitan al
               usuario la utilización de sus prestaciones o herramientas como, por ejemplo, identificar la sesión o 
               realizar el proceso de registro, entre otros. Sin estas cookies, las funciones mencionadas quedarían 
               inhabilitadas. 
            </Typography>
            <Typography paragraph>
              Al utilizar este Sitio Web, el usuario consiente el tratamiento su información en la forma y para los 
              fines arriba indicados. 
            </Typography>
            <Typography paragraph>
              Estas son las Cookies que se utilizan en el Sitio Web:
            </Typography>
            <Typography paragraph>
              <strong>De momento no utilizamos Cookies</strong>
            </Typography>
            <Typography paragraph variant="subheading">
              Cookies de Terceros
            </Typography>
            <Typography paragraph variant="subheading">
              Cookies analíticas de Google Analytics
            </Typography>
            <Typography paragraph>
              COSMOCARE utiliza Google Analytics, servicio prestado por Google, Inc., entidad cuya oficina principal está en 
              1600 Amphitheatre Parkway, Mountain View (California), CA 94043, Estados Unidos ("Google").
            </Typography>
            <Typography paragraph>
              Estas Cookies tienen el propósito de analizar el uso que hacen los usuarios del Sitio Web. La información 
              que genera la Cookie (incluyendo su dirección IP) será directamente transmitida y archivada por Google en 
              sus servidores de Estados Unidos. Google usará esta información por cuenta del prestador con el propósito 
              de seguir la pista de su uso del sitio, recopilando de la actividad del sitio y prestando otros servicios 
              relacionados con la actividad del Sitio Web y el uso de Internet. Google podrá transmitir dicha información 
              a terceros cuando así se lo requiera la legislación, o cuando dichos terceros traten la información por cuenta 
              de Google. Google no asociará su dirección IP con ningún otro dato de que disponga.
            </Typography>
            <Typography paragraph>
              Al utilizar este sitio consiente el tratamiento su información por Google en la forma y para 
              los fines arriba indicados. 
            </Typography>
            <Typography paragraph>
              Estas son las Cookies que se utilizan en el Sitio Web:
            </Typography>
            <Typography paragraph>
              N/A
            </Typography>
            <Typography paragraph>
              Si desea más información al respecto, puede visitar la siguiente URL http://www.google.com/intl/es/analytics/.
            </Typography>
            <Typography paragraph>
              Así, puede bloquear las Cookies a través de las herramientas de configuración del navegador, 
              o bien, puede configurar su navegador para que le avise cuando un servidor quiera guardar 
              una Cookie: 
            </Typography>
            <Typography paragraph className={classes.pl}>
              a) Si utiliza Microsoft Internet Explorer, encontrará la opción en el menú Herramientas > Opciones de Internet > Privacidad > 
              Configuración. Para saber más visite http://windows.microsoft.com/es-es/windows-vista/block-or-allow-Cookies y 
              http://windows.microsoft.com/es-es/windows7/how-to-manage-Cookies-in-internet-explorer-9.<br /><br />
              b) Si utiliza Firefox, encontrará la opción en el menú Herramientas > Opciones > Privacidad > Cookies. 
              Para saber más visite http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-Cookies-que-los-sitios-we.<br /><br />
              c) Si utiliza Chrome, en la sección de Opciones > Opciones avanzadas > Privacidad. Para saber más
              https://support.google.com/accounts/answer/61416?hl=es.  <br /><br />
              d) Si utiliza Opera, en la opción de Seguridad y Privacidad, podrá configurar el navegador. Para saber 
              más visite http://help.opera.com/Windows/11.50/es-ES/cookies.html.<br /><br />
              e) Si utiliza Safari encontrará la opción en el menú Preferencias/Privacidad. Más información 
              en: http://support.apple.com/kb/HT1677?viewlocale=es_ES.  
            </Typography>
            <Typography paragraph align="right">
              Última actualización: <strong>agosto de 2018</strong>
            </Typography>
          </Grid>
        </Grid>
      </main>
    )
  }
}

const mapStateToProps = (state) => {
  return {
      auth: state.auth
  };
};

export default withRouter(
  connect(mapStateToProps)(
    withStyles(styles)(CookiePolicy)
  )
);


// WEBPACK FOOTER //
// ./src/modules/shared/pages/CookiePolicy.js